import { PartnerModel } from '../../user/modal/partner-model';
import { BranchDocumentDetailsModel } from './branch-document-details-model';

export class BranchModel {
  id: number;
  name: string;
  description: string;
  address: string;
  code: string;

  pan: string;
  gstIn: string;
  branchName: string;
  bankName: string;
  authorisedSignatury: string;
  additionalNameForInvoice: string;
  ifscCode: string;
  accountNumber: string;
  accountHolderName: string;
  headerLogo: string;
  footerSign: string;
  footerNote: string;
  phoneNo: string;
  mobileNo: string;
  secondaryMobileNo: string;
  email: string;
  mailHost: string;
  mailPort: string;
  lat: number;
  lon: number;
  documentDetails: Array<BranchDocumentDetailsModel>;
  partner: PartnerModel;
  isDeleted = false;

  // Angular Use
  files: Array<File>;
  primaryCountryCode: number;
  secondaryCountryCode: number;
  primaryNumber: string;
  secondaryNumber: string;
  party: any;
}
